import Header from "./Header";
import _ from 'lodash';
import { useRef } from 'react';
import Footer from "./Footer";

const Page = ({ children }) => {
  const headerRef = useRef();

  const onScroll = _.debounce((e) => {
    const currentScrollY = e.target.scrollTop;
    currentScrollY !== 0 ? headerRef.current.detach() : headerRef.current.attach();
  }, 50);

  return (
    <div className="page">
      <Header ref={headerRef} />
      <main className="main" onScroll={onScroll}>
        {children}
        <Footer />
      </main>
    </div>
  )
}

export default Page;